import { Group } from 'components/Wizards/Catalogue/Types'
import Styles from './Sections.module.scss'
import { WizardListItemContainer } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItemContainer/ListItemContainer'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import React from 'react'
import { SectionProps } from './Types'
import { WizardButton } from '../WizardButton/WizardButton'
import { WizardCategoryCardGrid } from '../WizardCategoryCard/WizardCategoryCard'
import { SOCIAL_MEDIA_CARD_OVERRIDES } from '../constants'

interface Props extends SectionProps {
  channels: Group['channels']
  heading?: string
  withDoc?: boolean
  withDesign?: boolean
  children?: React.ReactNode
  withTopMargin?: boolean
}

export const Common = ({
  channels,
  heading,
  withDoc = false,
  withDesign = false,
  children,
  withTopMargin = false,
  forYouPageType,
  ...props
}: Props): React.ReactElement => {
  const { isMobile } = useResponsiveDesign()

  if (isMobile) {
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardListItemContainer
          wizards={channels}
          heading={heading}
          withDoc={withDoc}
          withDesign={withDesign}
          {...props}
        >
          {children}
        </WizardListItemContainer>
      </div>
    )
  }

  return (
    <div className={Styles.commonSectionContainer}>
      <WizardCategoryCardGrid heading={heading}>
        {channels.map((channelKey) => (
          <WizardButton
            key={channelKey}
            channelKey={channelKey}
            version={2}
            size="lg"
            cardInfoOverride={forYouPageType === 'getting_started' ? SOCIAL_MEDIA_CARD_OVERRIDES : undefined}
            {...props}
          />
        ))}
        {children}
      </WizardCategoryCardGrid>
    </div>
  )
}
